<table
    class="table-cerrix bordered rounded hoverable striped"
    [class.centered]="Centered"
    [class.bordered]="!NoBorder"
    [class.bordered-columns]="!NoColumnBorder"
    [class.p-0]="NoPadding"
>
    <thead>
        <tr>
            @if (selectedProp) {
                <th scope="col"></th>
            }
            @if (showID) {
                <th scope="col">{{ "identifier" | t }}</th>
            }
            @for (header of headers; track header) {
                <th scope="col" (click)="sortOnColumn(header)" [class.clickable]="columnSortEnabled">
                    {{ prettyHeaders[header] }}
                    @if (headerTooltips[header]) {
                        <i class="fas fa-question-circle" [title]="headerTooltips[header]"></i>
                    }
                    @if (columnSortEnabled && header === columnSortName) {
                        <i class="fas fa-sort-amount-{{ columnSortAsc ? 'up' : 'down' }}"></i>
                    }
                </th>
            }
            @if (config && config.overviewRowActions && config.overviewRowActions.length > 0) {
                <th scope="col">
                    {{ config.overviewRowActionsName }}
                </th>
            }
        </tr>
    </thead>
    <tbody [sortablejs]="data" [sortablejsOptions]="sortingOptions">
        @for (row of data; track row; let i = $index) {
            <tr
                class="hover-row"
                [attr.data-uiid]="'cerrix-table-row-' + i"
                [ngClass]="{ highlighted: activeRow && activeRow[idProp] == row[idProp] }"
                (click)="triggerClick(row)"
                (dblclick)="triggerDblClick(row)"
            >
                @if (selectedProp) {
                    <td>
                        <cerrix-checkbox [(value)]="row[selectedProp]"></cerrix-checkbox>
                    </td>
                }
                @if (showID) {
                    <td>{{ row[idProp] }}</td>
                }
                @for (header of headers; track header) {
                    <td class="text-truncate" style="max-width: 400px">
                        <workspace-cell
                            [configs]="rendererConfig"
                            [row]="row"
                            [header]="header"
                            [stretched]="false"
                            [attr.data-uiid]="'cerrix-table-' + header + '-row-' + i"
                        >
                        </workspace-cell>
                    </td>
                }
                @if (config && config.overviewRowActions && config.overviewRowActions.length > 0) {
                    <td>
                        @for (btnConfig of config.overviewRowActions; track btnConfig) {
                            <i
                                [class]="btnConfig.icon + ' ms-2 me-2'"
                                [matTooltip]="btnConfig.tooltip"
                                (click)="btnConfig.clickEvent(row)"
                                [hidden]="btnConfig.showProperty && !row[btnConfig.showProperty]"
                            ></i>
                        }
                    </td>
                }
            </tr>
        }
    </tbody>
</table>
